import { BackButton, StyledText } from "../../../components/common";
import { TriviaInfoCup } from "../../../components/svgs";
import { useTheme, useTrivia } from "../../../hooks";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";

const TriviaInfoModal = ({ onBackButtonClick }) => {
  const { themeContext, theme } = useTheme();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let history = useHistory();

  const { trivia, setActiveTrivia, saveTriviaUserDisqualified } = useTrivia();

  return (
    <div
      style={{
        position: "absolute",
        zIndex: 100,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.7)",
      }}
    >
      <div
        style={{
          boxSizing: "border-box",
          padding: "20px",
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          paddingInline: 15,
          backgroundColor: "white",
        }}
      >
        <StyledText style={{ marginTop: -1, fontSize: 24 }}>
          Pulse Trivia
        </StyledText>
        <BackButton onClick={onBackButtonClick} />
        <div style={{ alignSelf: "center" }}>
          <TriviaInfoCup />
        </div>
        <div>
          <StyledText style={{ fontSize: 22, fontFamily: "MTNMedium" }}>
            What is Pulse Trivia?
          </StyledText>
        </div>
        <StyledText
          style={{
            fontFamily: "MTNMedium",
          }}
        >
          Yo Peeps! Play our quiz and stand a chance to win prizes like Airtime,
          Data, Gift vouchers and many more! T&Cs apply.
        </StyledText>

        <OutlinedContainer color={background}>
          <StyledText style={{ fontFamily: "MTNMedium", fontSize: 18 }}>
            Tips
          </StyledText>

          {tips.map((note, index) => {
            return (
              <TipsContainer key={index}>
                <CircleContainer>
                  <Dot color={background} />
                </CircleContainer>
                <StyledText
                  style={{ marginBlockStart: 0, fontFamily: "MTNRegular" }}
                >
                  {note}
                </StyledText>
              </TipsContainer>
            );
          })}
        </OutlinedContainer>
      </div>
    </div>
  );
};

export default TriviaInfoModal;

const OutlinedContainer = styled.div`
  width: "90%";
  border-width: 2;
  border: 1.5px solid ${({ color }) => color};
  border-radius: 15px;
  padding-inline: 10px;
`;

const TipsContainer = styled.div`
  display: flex;
`;

const CircleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding-inline: 10px;
  margin-top: 5px;
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${({ color }) => color};
  margin-right: 10px;
`;

const tips = [
  "Trivia is played on special days such as Tuesdays, during MTN Events and Festivals",
  "The first 5 participants to answer all Trivia Tuesday questions correctly stand a chance to win a prize.",
  "The first 3 participants to answer all Festival Trivia questions correctly stand a chance to win a prize.",
  "The Festival and MTN Event Trivia are accessible on specified days.",
  "Trivia Tuesday on Tuesdays only.",
  "Completing the trivia is not a guarantee for a prize.",
  "Selected prizes if not Data/Airtime will be delivered to the nearest MTN service centre’s.",
  "Delivery status can be tracked on the App.",
  "This promo is exclusive on MyMTN App.",
];
const howToPlayText = [
  {
    triviType: "tuesday_trivia",
    howItWorks: [
      "You must be at the Ogua festival.",
      "You need to answer all 10 questions correctly in 90 seconds to stand a chance of winning a free voucher.",
      "The first participants to answer all questions correctly will win a free voucher.",
    ],
  },
  {
    triviType: "festive_trivia",
    howItWorks: [
      "You must be at the Ogua festival.",
      "You need to answer all 10 questions correctly in 90 seconds to stand a chance of winning a free voucher.",
      "The first participants to answer all questions correctly will win a free voucher.",
    ],
  },
  {
    triviaType: "true_or_false_trivia",
    howItWorks: [
      "You must be at the Ogua festival.",
      "You need to answer all 10 questions correctly in 90 seconds to stand a chance of winning a free voucher.",
      "The first participants to answer all questions correctly will win a free voucher.",
    ],
  },
];
